// extracted by mini-css-extract-plugin
module.exports = {"section_online_service":"main_section_online_service__18agR","header":"main_header__2bhHJ"};